import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Button,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface StoryWizardModalProps {
  open: boolean;
  onClose: () => void;
}

const StoryWizard: React.FC<StoryWizardModalProps> = ({ open, onClose }) => {
  const handleGenerate = () => {
    alert(
      "AI Story Generated! In a real app, this would use an AI API to craft a custom narrative based on your inputs.",
    );
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 6, p: 1 } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 0,
        }}
      >
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 900 }}>
            Campaign Story Assistant
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5 }}>
            We&apos;ll help you write a story that touches hearts.
          </Typography>
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{ pt: 3, display: "flex", flexDirection: "column", gap: 3 }}
      >
        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Church Name & Location
          </Typography>
          <TextField fullWidth placeholder="e.g. St. Jude Parish, Limpopo" />
        </Box>

        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Primary Challenge
          </Typography>
          <FormControl fullWidth>
            <Select
              defaultValue="no-light"
              sx={{ borderRadius: 4, bgcolor: "#f8fafc" }}
            >
              <MenuItem value="no-light">
                No night lighting for evening services
              </MenuItem>
              <MenuItem value="diesel">High cost of diesel generators</MenuItem>
              <MenuItem value="charging">
                Community needs phone charging stations
              </MenuItem>
              <MenuItem value="medical">
                Church medical clinic needs refrigeration
              </MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            A Personal Anecdote
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="Tell us about a time light (or lack of it) changed things..."
          />
        </Box>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleGenerate}
          sx={{ py: 1.5, fontSize: "1rem", fontWeight: 700, borderRadius: 3 }}
        >
          Generate My Story
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default StoryWizard;
